import AuthTemplate from "../templates/AuthTemplate";
import ProfileUnavailable from "../../components/Profile/ProfileUnavailable";
import React from "react";

const ProfileUnavailableView = () => {
	return (
		<AuthTemplate contentStyles={{ paddingX: 0 }}>
			<ProfileUnavailable />
		</AuthTemplate>
	);
};

export default ProfileUnavailableView;